import type { RouteObject } from "react-router";

import { ErrorPage } from "@/components/Error/ErrorPage";
import { canAccessCompanies } from "@/components/ProjectSidebar/permissions";
import { RequireAuth } from "@/components/Routing/RequireAuth";
import { canListAddresses } from "@/helpers/permissions";
import { canManageCompanies } from "@/helpers/permissions";

import { CompanyBulkUploadPage } from "./pages/CompanyBulkUploadPage";
import { CompanyListPage } from "./pages/CompanyListPage";
import { CreateCompanyPage } from "./pages/CreateCompanyPage";
import { EditCompanyPage } from "./pages/EditCompanyPage";
import { companyRoutes } from "./routes";

export const companyRoute = [
  {
    path: companyRoutes.list,
    element: (
      <RequireAuth permission={canAccessCompanies}>
        <CompanyListPage />
      </RequireAuth>
    ),
  },
  {
    path: companyRoutes.new,
    element: (
      <RequireAuth permission={canManageCompanies}>
        <CreateCompanyPage />
      </RequireAuth>
    ),
  },
  {
    path: companyRoutes.edit,
    element: (
      <RequireAuth permission={canManageCompanies}>
        <EditCompanyPage />
      </RequireAuth>
    ),
  },
  {
    path: companyRoutes.bulkUpload,
    element: (
      <RequireAuth permission={(x) => canListAddresses(x) && canManageCompanies(x)}>
        <CompanyBulkUploadPage />
      </RequireAuth>
    ),
  },
  {
    path: "*",
    element: <ErrorPage status={404} />,
  },
] satisfies RouteObject[];
